import { Injectable } from "@angular/core";
import { OutsourcingComponent } from "../external/outsourcing/outsourcing.component";
import { BehaviorSubject, Observer, Subscription } from "rxjs";
import {
    OutsourcingFormModel, OutsourcingFormQuestionTypeListResponseModel,
    OutsourcingFormSectionResponseModel, OutsourcingFormQuestionResponseModel
} from "../models/outsourcing-form.model";
import { ApiServiceDelegate } from "../models/api-service-delegate";
import { ApiCollection } from "../providers/api-collection";
import { ApiService } from "../services/api.service";
import { NzMessageService } from "ng-zorro-antd/message";
import { OutsourcingRequestVendorModel } from "../models/vendor.model";
import { HttpEventType, HttpResponse } from "@angular/common/http";
import { OutsourcingFormPreviewComponent } from "../external/outsourcing-form-preview/outsourcing-form-preview.component";
import { ExternalDeskFeedbackPayloadModel } from "../models/external-feedback.model";


@Injectable({
    providedIn: "root",
})

export class ExternalViewModel {

    parentOutsourcingComponent: OutsourcingComponent;
    outsourcingFormPreviewComponent:OutsourcingFormPreviewComponent;
    outsourcingFormDetailModel = new BehaviorSubject<OutsourcingFormModel>(
        new OutsourcingFormModel()
    );

    // formQuestionTypeListResponseModel = new BehaviorSubject<OutsourcingFormQuestionTypeListResponseModel>(
    //     new OutsourcingFormQuestionTypeListResponseModel()
    // );

    outsourcingFormSectionResponseModel = new BehaviorSubject<OutsourcingFormSectionResponseModel>(
        new OutsourcingFormSectionResponseModel()
    );

    outsourcingFormQuestionResponseModel = new BehaviorSubject<OutsourcingFormQuestionResponseModel>(
        new OutsourcingFormQuestionResponseModel()
    );
 
    outsourcingRequestVendorModel = new BehaviorSubject<OutsourcingRequestVendorModel>(
        new OutsourcingRequestVendorModel()
    );

    private externalEntryPoint = '/external';

    constructor(
        private apiService: ApiService,
        private message: NzMessageService
    ) { }

    subscribeToOutsourcingFormDetails(
        observer: Observer<OutsourcingFormModel>,
        observerSection: Observer<OutsourcingFormSectionResponseModel>,
        observerQuestions: Observer<OutsourcingFormQuestionResponseModel>,
        // observerQuestionsTypes: Observer<OutsourcingFormQuestionTypeListResponseModel>, 
        observerVendorRequest: Observer<OutsourcingRequestVendorModel>
        
    ) {
        this.outsourcingFormDetailModel.subscribe(observer);
        this.outsourcingFormSectionResponseModel.subscribe(observerSection);
        this.outsourcingFormQuestionResponseModel.subscribe(observerQuestions);
        // this.formQuestionTypeListResponseModel.subscribe(observerQuestionsTypes); 
        this.outsourcingRequestVendorModel.subscribe(observerVendorRequest);
    }
    subscribeToOutsourcingFormPreviewDetails(
        observer: Observer<OutsourcingFormModel>,
        observerSection: Observer<OutsourcingFormSectionResponseModel>,
        observerQuestions: Observer<OutsourcingFormQuestionResponseModel>,
  
    ) {
        this.outsourcingFormDetailModel.subscribe(observer);
        this.outsourcingFormSectionResponseModel.subscribe(observerSection);
        this.outsourcingFormQuestionResponseModel.subscribe(observerQuestions);
    }

     /**
   * Helper function to format backend validation errors for display.
   * @param errors The error object from the backend.
   * @returns A string containing formatted error messages.
   */
  private formatBackendErrors(errors: any): void {
    let errorMessages = '';
    if (typeof errors === 'object') {
      for (const key in errors) {
        if (errors.hasOwnProperty(key)) {
          errorMessages += `<strong>${key}:</strong> ${Array.isArray(errors[key]) ? errors[key].join(', ') : errors[key]}<br>`;
        }
      }
    } else {
      errorMessages = errors.toString();
    }
    this.message.error(errorMessages, { nzDuration: 1000 });
    // return errorMessages;
  }


    
    getVendorQuotationRequestById(id: string) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: this.externalEntryPoint + ApiCollection.OutsourcingRequestVendor + '/' + id,
            Success: (e: any) => {
                this.outsourcingRequestVendorModel.next(e);
                this.parentOutsourcingComponent.dataOutsourcingRequestVendorReceived();
                return e;
            },
            Error: (e: String) => {
                // this.message.error(String(e), { nzDuration: 1000 });
                this.formatBackendErrors(e)
                this.parentOutsourcingComponent.dataOutsourcingRequestVendorReceivedError();
                return e;
            },
        };
        this.apiService.callService(d);
    }



    // getQuestionTypeList() {
    //     let d: ApiServiceDelegate = {
    //         Data: {},
    //         Method: "GET",
    //         Action: this.externalEntryPoint + ApiCollection.OutsourcingFormQuestionType,
    //         Success: (e: any) => {
    //             this.formQuestionTypeListResponseModel.next(e);
    //             return e;
    //         },
    //         Error: (e: String) => {
    //             this.message.error(String(e), { nzDuration: 1000 });
    //             return e;
    //         },
    //     };
    //     this.apiService.callService(d);
    // }

    getOutSourcingFormById(id: string,caller:string) {
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: this.externalEntryPoint + ApiCollection.OutsourcingForm + '/' + id,
            Success: (e: any) => {
                this.outsourcingFormDetailModel.next(e);
                if(caller=='outsourcingComponent'){
                    this.parentOutsourcingComponent.dataReceived();
                }
                if(caller =='outsourcingFormPreviewComponent'){
                    this.outsourcingFormPreviewComponent.dataReceived();
                }
                return e;
            },
            Error: (e: String) => {
                // this.message.error(String(e), { nzDuration: 1000 });
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }


    getOSFormSections(id: string, caller:string) {
        const url = this.externalEntryPoint + ApiCollection.OutsourcingFormSection + "?page=1&page_size=100" + '&outsourcing_form=' + id;
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: url,
            Success: (e: any) => {
                this.outsourcingFormSectionResponseModel.next(e);
                if(caller=='outsourcingComponent'){
                    this.parentOutsourcingComponent.sectionsDataReceived();
                }
                if(caller =='outsourcingFormPreviewComponent'){
                    this.outsourcingFormPreviewComponent.sectionsDataReceived();
                }
                return e;
            },
            Error: (e: String) => {
                // this.message.error(String(e), { nzDuration: 1000 });
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }



    getOSQuestions(ids: string, caller:string) {
        const url = this.externalEntryPoint + ApiCollection.OutsourcingFormQuestion + "?page=1&page_size=100" + '&section=' + ids;
        let d: ApiServiceDelegate = {
            Data: {},
            Method: "GET",
            Action: url,
            Success: (e: any) => {
                this.outsourcingFormQuestionResponseModel.next(e);
                if(caller =='outsourcingComponent'){
                    this.parentOutsourcingComponent.questionsDataReceived();
                }
                if(caller =='outsourcingFormPreviewComponent' ){
                    this.outsourcingFormPreviewComponent.questionsDataReceived();
                }
                
                return e;
            },
            Error: (e: String) => {
                // this.message.error(String(e), { nzDuration: 1000 });
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }


        uploadMediaFile(item: any): Subscription {
            const formData = new FormData();
            formData.append('file', item.file as File);
            formData.append('name', item.file.name);
            // formData.append('created_by', userId);
          
            return this.apiService.uploadFileWithProgress(this.externalEntryPoint + ApiCollection.Media, formData).subscribe({
              next: (event) => {
                if (event.type === HttpEventType.UploadProgress) {
                  const percentDone = Math.round((100 * event.loaded) / (event.total || 1));
                    if (item.onProgress) {
                    item.onProgress({ percent: percentDone }, item.file);
                    } 
                } else if (event instanceof HttpResponse) {
                  if (item.onSuccess) {
                   item.onSuccess(event.body, item.file, event);
                  }
                }
              },
              error: (error) => {
                item.onError!(error, item.file);
              },
              complete: () => {
                console.log('Upload process completed.');
              }
            });
          }
    
    createdOutsourcing(data:any) {
        let d: ApiServiceDelegate = {
            Data: data,
            Method: "POST",
            Action: this.externalEntryPoint + ApiCollection.VendorSubmission,
            Success: (e: any) => {
                this.message.success("Request submitted successfully!", { nzDuration: 1000 })
                this.parentOutsourcingComponent.formSubmittedSuccessfully();
                return e;
            },
            Error: (e: String) => {
                // this.message.error(String(e), { nzDuration: 1000 });
                this.formatBackendErrors(e)
                return e;
            },
        };
        this.apiService.callService(d);
    }

    createExternalDeskFeedback(
        data: ExternalDeskFeedbackPayloadModel,
        success: (response: any) => string,
        error: (error: any) => string
    ) {
        let d: ApiServiceDelegate = {
            Data: data,
            Method: "POST",
            Action: ApiCollection.ExternalDeskFeedbackStore,
            Success: success,
            Error: error,
        };
        this.apiService.callService(d);
    }

}
